import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import { storage } from '@core/services/firebase/firebase-service'
import { ImageErrorConverter } from '@core/services/image/converters/image-error-converter'

function sanitizeFileName(fileName: string) {
  return fileName.replace(/[^a-zA-Z0-9._-]/g, '_')
}

function getFileExtension(fileName: string): string {
  const sanitized = sanitizeFileName(fileName)
  const extension = sanitized.split('.').pop()
  if (!extension || extension === sanitized) {
    return ''
  }
  return `.${extension}`
}

function getUserUploadsPath(userId: string, fileName: string) {
  const timestamp = Date.now()
  return `users/${userId}/uploads/${timestamp}${getFileExtension(fileName)}`
}

function getStorageOrThrow() {
  if (!storage) {
    throw ImageErrorConverter.domainModel(
      new Error('Firebase Storage is not initialized'),
    )
  }
  return storage
}

export class ImageService {
  private static instance: ImageService

  private constructor() {}

  public static getInstance(): ImageService {
    if (!ImageService.instance) {
      ImageService.instance = new ImageService()
    }
    return ImageService.instance
  }

  public async uploadUserImage(userId: string, file: File): Promise<string> {
    try {
      const filePath = getUserUploadsPath(userId, file.name || 'profile-image')
      const storageRef = ref(getStorageOrThrow(), filePath)
      const snapshot = await uploadBytes(storageRef, file, {
        contentType: file.type || 'application/octet-stream',
      })
      return await getDownloadURL(snapshot.ref)
    } catch (error) {
      throw ImageErrorConverter.domainModel(error)
    }
  }

  public async uploadUserProfileImage(userId: string, file: File): Promise<string> {
    return this.uploadUserImage(userId, file)
  }
}
